import React from 'react';

export function FoundationPage({ title = 'WatchVIM' }) {
  return (
    <section className="foundation-page" aria-live="polite">
      <div className="foundation-card compact">
        <span className="eyebrow">WatchVIM</span>
        <h1>{title}</h1>
        <p>Opening the requested WatchVIM destination…</p>
      </div>
    </section>
  );
}
